<template>
  <v-dialog
    v-model="markAsPaidDialog"
    persistent
    max-width="600px"
  >
    <div>
      <VWidget :title="$t('Mark order {0} as paid', [order.number])">
        <v-layout
          slot="widget-content"
          row
          wrap
        >
          <v-flex xs12>
            {{ $t('Are you sure that you want to mark this order as paid?') }}
          </v-flex>
        </v-layout>
      </VWidget>
      <v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :loading="markAsPaidInProgress"
            class="primary"
            flat
            small
            @click="markAsPaid()"
          >
            {{ $t('Mark as paid') }}
          </v-btn>
          <v-btn
            color="darken-1"
            flat
            small
            @click="$emit('close-mark-as-paid-dialog')"
          >
            {{ $t('Close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'OrderSingleMarkAsPaidDialog',

  props: {
    order: {
      type: Object,
      required: true
    },
    markAsPaidDialog: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      markAsPaidInProgress: false
    }
  },

  methods: {
    async markAsPaid () {
      this.markAsPaidInProgress = true

      try {
        const orderResource = this.$http.make('order')
        await orderResource.markAsPaid(this.order.number)
        this.$toast.success(this.$t('Order marked as paid.'))
        this.$radio.$emit('order-marked-as-paid')
        this.markAsPaidInProgress = false
        this.$emit('close-mark-as-paid-dialog')
      } catch (error) {
        this.markAsPaidInProgress = false
        this.$emit('close-mark-as-paid-dialog')
      }
    }
  }
}
</script>
